import { useState, useEffect } from "react";
import { getMCubeEngageWhatsappTemplates } from "./service";

export default function useMCubeEngageWhatsappTemplates(workspaceId) {
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchTemplates = async () => {
    const init = () => {
      setLoading(true);
    };

    const success = (data) => {
      setTemplates(data);
      setLoading(false);
    };

    const error = (e) => {
      setLoading(false);
      console.error(e);
    };

    init();

    try {
      const request = { params: { workspaceId } };
      const response = await getMCubeEngageWhatsappTemplates(request);
      const { templates = [] } = response.data;

      success(templates);
    } catch (e) {
      error(e);
    }
  };

  useEffect(() => {
    if (workspaceId) {
      fetchTemplates();
    }
  }, [workspaceId]);

  return {
    templates: {
      data: templates,
      loading,
    },
    fetchTemplates,
  };
}
